module.exports = __webpack_public_path__ + "static/media/sh_1.50bcd271.wav";